import { findLayersInProjectUuid, saveLayer } from "@/api/geometry/layer";
import { LineType } from "pytha";
import genUUID from "./gen-uuid";
import { graphicStore } from "../store/graphic-store";
import { getLayerTypeName } from "@/commons/enums/layer-type";

/**
 * 将图元布置在单独的图层,
 * 若当前有图元图层，则布置在图元图层,
 * 否则，添加一个图层
 */
export function getSpecialPrimitiveLayerUuid(projectUuid: string, modelUuid: string, layerType: number, color: string = "#000000") {
    return new Promise((resolve, reject) => {
        if (!getLayerTypeName(layerType)) {
            reject('图层类型不存在');
            return;
        }
        findLayersInProjectUuid(projectUuid, modelUuid).then(res => {
            let layers = res.data || [];
            let layer = layers.find(layer => layer.type === layerType);
            if (layer) {
                resolve(layer.uuid);
            } else {
                let uuid = genUUID();
                let newLayer: any = {
                    uuid: uuid,
                    name: getLayerTypeName(layerType),
                    color: color,
                    lineWidth: 0.25,
                    lineType: LineType.BASE_LINE,
                    lock: false,
                    hidden: false,
                    originLayer: false,
                    type: layerType,
                    projectUuid: projectUuid,
                };
                saveLayer(newLayer, projectUuid, modelUuid).then(_ => {
                    //更新几何库图层
                    let newLayers = [...graphicStore.context.layerContext.layers, newLayer];
                    graphicStore.context.layerContext.setLayers(newLayers);
                    resolve(newLayer.uuid);
                }).catch(err => {
                    reject('添加图层失败');
                }).finally(() => {

                })
            }
        }).catch(err => {
            reject('获取图层失败');
        }).finally(() => {

        })
    })
}